import { render, staticRenderFns } from "./Pillar6.vue?vue&type=template&id=fd962838&"
import script from "./Pillar6.vue?vue&type=script&lang=js&"
export * from "./Pillar6.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports